import { withNamespaces } from "react-i18next";

const DeletionStatus = ({ t, isDeleted, deletionReason }) => {
    if (!isDeleted) return null;

    const { reason, otherReason } = deletionReason || {};

    return (
        <div className="alert alert-warning">
            <div>
                <strong>{t('Status')}:</strong> {t('Deleted')}
            </div>

            {reason && (
                <div className="mt-2">
                    <strong>{t('Deletion Reason')}:</strong> {reason}
                </div>
            )}

            {reason?.toLowerCase() === "other" && otherReason && (
                <div className="mt-1">
                    <strong>{t('Details')}:</strong> {otherReason}
                </div>
            )}
        </div>
    );
}

export default withNamespaces()(
    DeletionStatus
);